import { RegSettingDetail } from 'src/settings/models/regSetting';
import AxiosInstance from './axios/interceptor';

const controller = 'RegSetting';

export const getMainSettings = () => {
  return AxiosInstance.get<RegSettingDetail[]>(`${controller}/Main`);
};

export const updateMainSettings = (data: RegSettingDetail[]) => {
  return AxiosInstance.put(`${controller}/Main`, data);
};

export const getOnboardingSettings = () => {
  return AxiosInstance.get<RegSettingDetail[]>(`${controller}/Onboarding`);
};

export const updateOnboardingSettings = (data: RegSettingDetail[]) => {
  return AxiosInstance.put(`${controller}/Onboarding`, data);
};

export const getDashboardSettings = () => {
  return AxiosInstance.get<RegSettingDetail[]>(`${controller}/Dashboard`);
};

export const updateDashboardSettings = (data: RegSettingDetail[]) => {
  return AxiosInstance.put(`${controller}/Dashboard`, data);
};
